import Joi from '@hapi/joi'

export const FactoryItemApprovalSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({ "any.invalid": `Group Required`, }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({ "any.invalid": `Operation Entity Required`, }),
    collectionPointID: Joi.number().invalid(0).required().label("Collection Point").messages({"any.invalid": `Collection Point required`,}),
    statusID: Joi.number().label("Status").messages({
        "any.invalid": `Please select valid Status`,
        "any.required": `Status required`
    }),
}